module.exports = __webpack_public_path__ + "img/antes_despues_131.80179cc8.png";